import React, { useState, useEffect } from "react"
import {
  AppBar,
  Toolbar,
  Button,
  Container,
  Box,
  Menu,
  MenuItem,
  IconButton,
  useMediaQuery,
  useTheme,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Divider,
  Collapse,
} from "@mui/material"
import MenuIcon from "@mui/icons-material/Menu"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import ExpandLessIcon from "@mui/icons-material/ExpandLess"
import PhoneIcon from "@mui/icons-material/Phone"
import WhatsAppIcon from "@mui/icons-material/WhatsApp"
import { Link, useLocation } from "react-router-dom"
import { MENU_DATA } from "../../config/menu.js"
import SubHeader from "../Header/SubHeader"
import { useDispatch, useSelector } from "react-redux"
import { getMegaMenus } from "../../features/megaMenuSlice"

const Header = () => {
  const theme = useTheme()
  const location = useLocation()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))
  const [mobileOpen, setMobileOpen] = useState(false)
  const [servicesOpen, setServicesOpen] = useState(false)
  const [resourcesOpen, setResourcesOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const [activePath, setActivePath] = useState("/")
  const [servicesOpenMenu, setServicesOpenMenu] = useState(false)
  const [resourcesOpenMenu, setResourcesOpenMenu] = useState(false)
  const [sticky, setSticky] = useState(false)

  const dispatch = useDispatch()
  const { list: megaMenu, loading } = useSelector((state) => state.megaMenu)

  useEffect(() => {
    dispatch(getMegaMenus())
  }, [dispatch])

  useEffect(() => {
    setActivePath(location.pathname)
    // Close mobile menu when route changes
    setMobileOpen(false)
  }, [location])

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  const handleServicesClick = (event) => {
    if (isMobile) {
      setServicesOpen(!servicesOpen)
    } else {
      setAnchorEl(event.currentTarget)
      setServicesOpenMenu(true)
      setResourcesOpenMenu(false)
    }
  }

  const handleResourcesClick = (event) => {
    if (isMobile) {
      setResourcesOpen(!resourcesOpen)
    } else {
      setAnchorEl(event.currentTarget)
      setResourcesOpenMenu(true)
      setServicesOpenMenu(false)
    }
  }

  const handleClose = () => {
    setAnchorEl(null)
    setServicesOpenMenu(false)
    setResourcesOpenMenu(false)
  }

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  const menuItems = [
    { title: "Home", path: "/" },
    { title: "About Us", path: "/about" },
    { title: "Services", path: "/services" },
    { title: "Latest Blogs", path: "/articles" },
    { title: "Contact Us", path: "/contact" },
  ]

  const isActive = (path) => {
    if (path === "/") {
      return activePath === path
    }
    // For submenu items, check for exact match or parent path
    return (
      activePath === path ||
      (path !== "/" &&
        activePath.startsWith(path) &&
        (activePath[path.length] === "/" || activePath.length === path.length))
    )
  }

  const getButtonSx = (path) => ({
    mx: 1,
    color: isActive(path) ? "primary.main" : "text.primary",
    // borderBottom: isActive(path) ? '2px solid' : 'none',
    borderColor: "primary.main",
    borderRadius: 0,
    fontWeight: isActive(path) ? "900" : "500",
    "&:hover": {
      color: "primary.dark",
      backgroundColor: "rgba(0, 0, 0, 0.02)",
    },
  })

  const [openCategory, setOpenCategory] = useState(null)

  const handleCategoryToggle = (key) => {
    setOpenCategory(openCategory === key ? null : key)
  }

  const renderDesktopMenu = () => (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexGrow: 1,
        ml: 4,
        position: "relative",
      }}
    >
      {menuItems.map((item) => (
        <div key={item.title}>
          {item.submenu ? (
            <>
              <Button
                component={item.submenu ? "div" : Link}
                to={!item.submenu ? item.path : null}
                color='inherit'
                onClick={(e) => {
                  if (item.title === "Industries") {
                    e.preventDefault()
                    setAnchorEl(e.currentTarget)
                    setServicesOpenMenu(true)
                    setResourcesOpenMenu(false)
                  } else if (item.title === "Services") {
                    handleServicesClick(e)
                  } else if (item.title === "Resources") {
                    handleResourcesClick(e)
                  }
                }}
                endIcon={item.submenu ? <ExpandMoreIcon /> : null}
                sx={getButtonSx(item.path)}
              >
                {item.title}
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={servicesOpenMenu && item.title === "Industries"}
                onClose={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    mt: 1.5,
                    width: "100%",
                    maxWidth: "100%",
                    left: 0,
                    right: 0,
                    maxHeight: "80vh",
                    overflow: "auto",
                    borderRadius: 0,
                    bgcolor: "#008080",
                    color: "white",
                    p: 3,
                    "& .MuiMenu-paper": {
                      width: "100%",
                      maxWidth: "100%",
                    },
                  },
                }}
                MenuListProps={{
                  sx: {
                    maxWidth: "lg",
                    margin: "0 auto",
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", md: "repeat(4, 1fr)" },
                    gap: 2,
                    p: 2,
                    width: "100%",
                  },
                }}
                sx={{
                  "& .MuiPaper-root": {
                    position: "absolute",
                    left: 0,
                    right: 0,
                  },
                }}
              >
                {item.title === "Industries" &&
                  item.submenu.map((subItem, index) => (
                    <MenuItem
                      key={subItem.title}
                      component={Link}
                      to={subItem.path}
                      onClick={handleClose}
                      sx={{
                        color: "white",
                        "&:hover": {
                          backgroundColor: "rgba(255, 255, 255, 0.1)",
                        },
                        whiteSpace: "normal",
                        py: 1,
                        px: 2,
                        borderRadius: "4px",
                      }}
                    >
                      {subItem.title}
                    </MenuItem>
                  ))}
                <Box
                  sx={{
                    gridColumn: "1 / -1",
                    display: "flex",
                    justifyContent: "center",
                    mt: 2,
                    pt: 2,
                    borderTop: "1px solid rgba(255, 255, 255, 0.2)",
                  }}
                >
                  <Button
                    variant='contained'
                    color='primary'
                    component={Link}
                    to='/services'
                    onClick={handleClose}
                    sx={{
                      bgcolor: "white",
                      color: "#008080",
                      "&:hover": {
                        bgcolor: "rgba(255, 255, 255, 0.9)",
                      },
                      px: 4,
                      py: 1,
                      fontWeight: "bold",
                      textTransform: "none",
                      borderRadius: "4px",
                    }}
                  >
                    Explore All Industries
                  </Button>
                </Box>
              </Menu>
            </>
          ) : (
            <Button
              color='inherit'
              component={Link}
              to={item.path}
              sx={getButtonSx(item.path)}
            >
              {item.title}
            </Button>
          )}
        </div>
      ))}
    </Box>
  )

  const renderMobileMenu = () => (
    <Box sx={{ width: 280 }}>
      <List>
        {/* ===== PRIMARY MENU ITEMS ===== */}
        {menuItems.map((item) => (
          <Box key={item.title}>
            <ListItem
              button
              component={Link}
              to={item.path}
              onClick={handleDrawerToggle}
              sx={{
                backgroundColor: isActive(item.path)
                  ? "rgba(25,118,210,0.08)"
                  : "transparent",
              }}
            >
              <ListItemText
                primary={item.title}
                primaryTypographyProps={{
                  fontWeight: isActive(item.path) ? 600 : 400,
                  textTransform: "none",
                }}
              />
            </ListItem>
            <Divider />
          </Box>
        ))}

        {/* ===== DYNAMIC MEGA MENU ===== */}
        {!loading &&
          megaMenu.map((menu) => (
            <Box key={menu.menu_key}>
              {/* TOP LEVEL */}
              <ListItem
                button
                onClick={() => handleCategoryToggle(menu.menu_key)}
                sx={{
                  backgroundColor:
                    openCategory === menu.menu_key
                      ? "rgba(25,118,210,0.08)"
                      : "transparent",
                }}
              >
                <ListItemText
                  primary={menu.title}
                  primaryTypographyProps={{
                    fontWeight: 600,
                    textTransform: "none",
                  }}
                />
                {openCategory === menu.menu_key ? (
                  <ExpandLessIcon />
                ) : (
                  <ExpandMoreIcon />
                )}
              </ListItem>

              {/* SECTIONS */}
              <Collapse
                in={openCategory === menu.menu_key}
                timeout='auto'
                unmountOnExit
              >
                <List component='div' disablePadding>
                  {menu.data?.sections?.map((section, i) => (
                    <Box key={i}>
                      {/* SECTION HEADING */}
                      <ListItem sx={{ pl: 3 }}>
                        <ListItemText
                          primary={section.heading}
                          primaryTypographyProps={{
                            fontSize: 14,
                            fontWeight: 600,
                            color: "text.secondary",
                            textTransform: "none",
                          }}
                        />
                      </ListItem>

                      {/* SECTION ITEMS */}
                      {section.items?.map((item, idx) => (
                        <ListItem
                          key={idx}
                          button
                          component={Link}
                          to={item.link}
                          onClick={handleDrawerToggle}
                          sx={{
                            pl: 5,
                            "&:hover": {
                              backgroundColor: "rgba(0,0,0,0.04)",
                            },
                          }}
                        >
                          <ListItemText
                            primary={item.label}
                            primaryTypographyProps={{
                              fontSize: 14,
                              textTransform: "none",
                            }}
                          />
                        </ListItem>
                      ))}
                    </Box>
                  ))}
                </List>
              </Collapse>

              <Divider />
            </Box>
          ))}
      </List>

      {/* ===== FOOTER ACTIONS ===== */}
      <Box sx={{ p: 2, textAlign: "center" }}>
        <IconButton href='tel:8818888744' color='primary' aria-label='Call us'>
          <PhoneIcon />
        </IconButton>

        <IconButton
          href='https://wa.me/918818888744'
          target='_blank'
          rel='noopener noreferrer'
          color='primary'
        >
          <WhatsAppIcon />
        </IconButton>

        <Button
          variant='contained'
          component={Link}
          to='/contact'
          fullWidth
          sx={{ mt: 2, textTransform: "none" }}
          onClick={handleDrawerToggle}
        >
          Talk Expert
        </Button>
      </Box>
    </Box>
  )

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setSticky(true)
      } else {
        setSticky(false)
      }
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return (
    <AppBar
      position={sticky ? "fixed" : "static"}
      elevation={sticky ? 4 : 1}
      sx={{
        bgcolor: "white",
        color: "text.primary",
        boxShadow: "0 1px 2px rgba(0,0,0,0.08), 0px 1px 5px rgba(0,0,0,0.10)",
      }}
    >
      <Container maxWidth='lg'>
        <Toolbar disableGutters>
          <Link to='/'>
            <img
              src='/logo.png'
              alt='Logo'
              style={{ height: 40, marginRight: 16, cursor: "pointer" }}
            />
          </Link>

          {!isMobile && renderDesktopMenu()}

          <Box
            sx={{ display: "flex", alignItems: "center", ml: "auto", gap: 1 }}
          >
            {!isMobile && (
              <>
                <IconButton
                  href='tel:8818888744'
                  color='primary'
                  aria-label='Call us'
                  sx={{
                    color: "primary.main",
                    "&:hover": {
                      backgroundColor: "rgba(25, 118, 210, 0.04)",
                    },
                  }}
                >
                  <PhoneIcon />
                </IconButton>
                <IconButton
                  href='https://wa.me/918818888744'
                  target='_blank'
                  rel='noopener noreferrer'
                  color='primary'
                  aria-label='WhatsApp us'
                  sx={{
                    color: "primary.main",
                    "&:hover": {
                      backgroundColor: "rgba(25, 118, 210, 0.04)",
                    },
                  }}
                >
                  <WhatsAppIcon />
                </IconButton>
                <Button
                  variant='contained'
                  color='primary'
                  component={Link}
                  to='/contact'
                  sx={{ ml: 1 }}
                >
                  Talk Expert
                </Button>
              </>
            )}
            {isMobile && (
              <IconButton
                color='inherit'
                aria-label='open drawer'
                edge='start'
                onClick={handleDrawerToggle}
                sx={{ ml: "auto" }}
              >
                <MenuIcon />
              </IconButton>
            )}
          </Box>
        </Toolbar>
      </Container>
      {!isMobile && <SubHeader />}
      <Drawer
        anchor='right'
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
      >
        {renderMobileMenu()}
      </Drawer>
    </AppBar>
  )
}

export default Header
